module.exports = __webpack_public_path__ + "media/application/images/svgs/quote-fill-c3fb8db2e67fee48b6f8f253602fcf23.svg";